// Inkoop per project — pure hulpjes (zonder React), gedeeld door het paneel en de tests.
// De server rekent het bedrag zelf opnieuw uit; dit is alleen voor de live preview.

export const AFSPRAKEN = [
  { value: 'dag', label: 'Dagprijs', eenheid: 'dag', eenheden: 'dagen' },
  { value: 'uur', label: 'Uurprijs', eenheid: 'uur', eenheden: 'uur' },
  { value: 'vast', label: 'Vast bedrag', eenheid: '×', eenheden: '×' },
];

const getal = (v) => {
  if (v === '' || v == null) return null;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

export function berekenBedrag(tarief, aantal) {
  const t = getal(tarief) ?? 0;
  const a = getal(aantal) ?? 1;
  return Math.round(t * a * 100) / 100;
}

export function formatEuro(bedrag) {
  const n = Number(bedrag) || 0;
  return n.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
}

export function formatAantal(n) {
  const r = Math.round((Number(n) || 0) * 100) / 100;
  return String(r).replace('.', ',');
}

// "2 dagen à € 650" / "7,5 uur à € 80" / "vast € 1.200"
export function afspraakTekst(regel, magBedragen) {
  const a = AFSPRAKEN.find((x) => x.value === regel.afspraak) || AFSPRAKEN[0];
  const aantal = Number(regel.aantal) || 0;
  if (a.value === 'vast') {
    const deel = aantal !== 1 ? `${formatAantal(aantal)} × ` : '';
    return magBedragen && regel.tarief != null ? `${deel}vast ${formatEuro(regel.tarief)}` : `${deel}vast bedrag`;
  }
  const eenheid = aantal === 1 ? a.eenheid : a.eenheden;
  const basis = `${formatAantal(aantal)} ${eenheid}`;
  return magBedragen && regel.tarief != null ? `${basis} à ${formatEuro(regel.tarief)}` : basis;
}

export const leegFormulier = () => ({ leverancier: '', leverancier_ref: null, afspraak: 'dag', tarief: '', aantal: '1', omschrijving: '' });

export function formulierUitRegel(r) {
  return {
    leverancier: r.leverancier || '', leverancier_ref: r.leverancier_ref || null, afspraak: r.afspraak || 'dag',
    tarief: r.tarief != null ? String(r.tarief).replace('.', ',') : '', aantal: String(r.aantal ?? 1).replace('.', ','),
    omschrijving: r.omschrijving || '',
  };
}

// Body voor POST/PATCH. Zonder bedragrecht gaat het tarief niet mee (de server weigert het).
export function naarBody(form, magBedragen) {
  const body = {
    leverancier: String(form.leverancier || '').trim(),
    leverancier_ref: form.leverancier_ref || null,
    afspraak: form.afspraak,
    aantal: getal(form.aantal) ?? 1,
    omschrijving: String(form.omschrijving || '').trim(),
  };
  if (magBedragen) body.tarief = getal(form.tarief) ?? 0;
  return body;
}

export function formulierFout(form, magBedragen) {
  if (!String(form.leverancier || '').trim()) return 'Kies of typ een freelancer of leverancier';
  const aantal = getal(form.aantal);
  if (form.aantal !== '' && (aantal == null || aantal < 0)) return 'Aantal moet een getal zijn';
  if (magBedragen && form.tarief !== '' && (getal(form.tarief) == null || getal(form.tarief) < 0)) return 'Tarief moet een getal zijn';
  return null;
}
